export function getK5aPosition(el: HTMLElement): number | undefined {
  try {
    const parent: HTMLElement | null = el?.closest('.guest,.kur_room')
    const ecPosition = parent?.dataset?.ecPosition
    if (!ecPosition) {
      return undefined
    }
    return parseInt(ecPosition)
  } catch {
    return undefined
  }
}

export function getK5aRow(el: HTMLElement): number | undefined {
  try {
    const parent: HTMLElement | null = el?.closest('.kur-floor__content')
    const ecList = parent?.dataset?.ecList
    if (!ecList) {
      return undefined
    }
    return parseInt(ecList.replace('nrkno_forside_floor_', ''))
  } catch {
    return undefined
  }
}
